import { render, staticRenderFns } from "./PlayerReport.vue?vue&type=template&id=f19124a0&scoped=true&"
import script from "./PlayerReport.vue?vue&type=script&lang=js&"
export * from "./PlayerReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f19124a0",
  null
  
)

export default component.exports